import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from './ui/navigation-menu';
import { companyInfo } from '../mockData';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-white border-b border-gray-100'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            {/* <div className="w-12 h-12 bg-[#004494] rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">HCS</span>
            </div>
            <div className="hidden md:block">
              <h1 className="text-xl font-bold text-[#004494] font-heading">
                {companyInfo.name}
              </h1>
              <p className="text-xs text-gray-600">{companyInfo.tagline}</p>
            </div> */}
            <img src="/logo.webp" className='header-logo'/>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors ${
                isActive('/')
                  ? 'text-[#004494] font-semibold'
                  : 'text-gray-700 hover:text-[#004494]'
              }`}
            >
              Home
            </Link>
            <Link
              to="/products"
              className={`text-sm font-medium transition-colors ${
                isActive('/products')
                  ? 'text-[#004494] font-semibold'
                  : 'text-gray-700 hover:text-[#004494]'
              }`}
            >
              Products & Services
            </Link>
            <Link
              to="/portfolio"
              className={`text-sm font-medium transition-colors ${
                isActive('/portfolio')
                  ? 'text-[#004494] font-semibold'
                  : 'text-gray-700 hover:text-[#004494]'
              }`}
            >
              Portfolio
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-medium transition-colors ${
                isActive('/contact')
                  ? 'text-[#004494] font-semibold'
                  : 'text-gray-700 hover:text-[#004494]'
              }`}
            >
              Contact
            </Link>
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Link to="/contact">
              <Button
                className="bg-[#004494] hover:bg-[#003370] text-white px-6 py-2 rounded-lg font-medium shadow-md hover:shadow-xl"
              >
                Request Quote
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gray-700 hover:text-[#004494] transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg">
          <nav className="px-4 py-6 space-y-4">
            <Link
              to="/"
              className="block text-base font-medium text-gray-700 hover:text-[#004494] transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/products"
              className="block text-base font-medium text-gray-700 hover:text-[#004494] transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Products & Services
            </Link>
            <Link
              to="/portfolio"
              className="block text-base font-medium text-gray-700 hover:text-[#004494] transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Portfolio
            </Link>
            <Link
              to="/contact"
              className="block text-base font-medium text-gray-700 hover:text-[#004494] transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Contact
            </Link>
            <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
              <Button className="w-full bg-[#004494] hover:bg-[#003370] text-white">
                Request Quote
              </Button>
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};